import { AppButton, AppModal } from "components";
import React, { useState } from "react";
import { styled } from "styled-components";
import { useTranslation } from "react-i18next";

const CustomButton = styled(AppButton)`
  min-width: 120px;
`;

const OptionChain = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <CustomButton onClick={() => setIsVisible(true)}>
        {t("terminal.common_options.option_chain_options.option_chain")}
      </CustomButton>

      <AppModal
        title={t("terminal.common_options.option_chain_options.chain_chart")}
        open={isVisible}
        onOk={() => setIsVisible(false)}
        onCancel={() => setIsVisible(false)}
      >
        {t("terminal.common_options.option_chain_options.chart_goes_here")}
      </AppModal>
    </>
  );
};

export default OptionChain;
